import { Component, Input, ViewChild, ContentChild } from "@angular/core";

@Component({
    selector: "tab",
    template: `
    <div [hidden]="!active" class="tab-content">
      <ng-content></ng-content>
    </div>
  `
})
export class Tab {
    @Input("tabTitle") title: string;
    @Input() active = false;

    @ContentChild("inner") inner;

    ngAfterViewInit():void {
        console.log("inner component: ", this.inner);
    }

    public activate():void {
        this.inner.makeActive();
    }

    public deactivate():void {
        this.inner.makeInactive();
    }

}
